import {useEventSoundPolling} from '../../redux/app/hooks/useEventSoundPolling';

export const EventSoundPolling = () => {
  useEventSoundPolling();
  return null;
};
